module.exports = __webpack_public_path__ + "img/bg-1.f4481862.png";